/* version */ function _(require, module, exports) {
    exports.version = '1.3.4';
}
